<template>
  <footer class="flex-center footer">
    <!-- <img src="../assets/images/dashboard/dzjg.png" alt="党政机关" /> -->
    <!-- <p class="vertical-bar"></p> -->
    <div class="footer-wrap flex">
      <div class="footer-info-item">
        <p>
          <router-link :to="!userData ? '/' : '/home/about'">关于本网</router-link>
          <span class="space">|</span>
          <router-link :to="!userData ? '/' : '/home/statement'">本站声明 </router-link>
          <span class="space">|</span>
          <router-link :to="!userData ? '/' : '/home/newman-guide'">帮助中心 </router-link>
          <span class="space">|</span>
          <router-link :to="!userData ? '/' : '/home/connect'">反馈建议</router-link>
        </p>
        <!-- <p>
          主办单位：{{ zbf }}<span class="margin-base">建设单位：{{ zbf }}</span
          ><span class="margin-base">运行单位：{{ zbf }}</span>
        </p> -->
        <p>
          建设单位：{{ zbf }}<span class="margin-base">技术运维：{{ jszc }}</span>
        </p>
        <!-- <p>
          业务咨询：{{ ywzx }}
          <span class="margin-base">技术咨询：{{ jszx }}</span>
        </p> -->
        <p>
          备案号：{{ beianxh }}
          <span class="margin-base"
            ><img class="badge" src="../assets/images/dashboard/hz.png" alt="徽章" />{{ gwab }}
            <!-- <span class="margin-base">政府网站标识码：{{ zhengf }}</span> -->
          </span>
        </p>
        <!--        <p>服务热线：{{ rxfw }}</p>-->
      </div>
    </div>
  </footer>
</template>

<script>
import { localDataUser } from '@/pages/iebdc/utils/local-data.js';
export default {
  data() {
    return {
      address: window.CONFIG.APP_INFO.address,
      systemphone: window.CONFIG.APP_INFO.systemphone,
      zbf: window.CONFIG.APP_INFO.zbf,
      ywzx: window.CONFIG.APP_INFO.ywzx,
      jszx: window.CONFIG.APP_INFO.jszx,
      userData: localDataUser.get(),
      beianxh: window.CONFIG.APP_INFO.beianxh,
      gwab: window.CONFIG.APP_INFO.gwab,
      zhengf: window.CONFIG.APP_INFO.zhengf,
      rxfw: window.CONFIG.APP_INFO.rxfw,
      jszc: window.CONFIG.APP_INFO.jszc,
    };
  },
};
</script>
<style lang="scss" scoped>
@import '~@/pages/iebdc/styles/common-variables.scss';
footer {
  width: 100%;
  background: #143050;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  height: 148px;
  .vertical-bar {
    width: 1px;
    height: 100px;
    border-right: 1px solid #ffff;
    margin: $spacing-large;
  }
  .footer-wrap {
    margin-left: $spacing-base;
    a:hover {
      border-bottom: #fff 2px solid;
    }
    p {
      line-height: 30px;
    }
    .space {
      margin: $spacing-base;
    }
    .margin-base {
      margin-left: $spacing-base;
    }
    .badge {
      position: relative;
      bottom: -3px;
      margin-right: $spacing-base;
    }
  }
}
</style>
